module.exports = __webpack_public_path__ + "media/images/product-img-03-39361ab2f698067694d3b1dbef633f84.png";